// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal__alert{max-width:350px}.modal__alert .modal__header-note{line-height:1.4}`, "",{"version":3,"sources":["webpack://./src/modals/Alert/style.scss"],"names":[],"mappings":"AACA,cACE,eAAA,CAEA,kCACE,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
